<template>
  <div id="businessList">
    <div class="container">
      <el-row>
        <div class="left">
          <el-button
            size="small"
            :class="type == 1 ? 'heightLight' : ''"
            @click="getData(1)"
            >公司简介</el-button
          >
          <el-button
            size="small"
            :class="type == 2 ? 'heightLight' : ''"
            @click="getData(2)"
            >企业文化</el-button
          >
          <el-button
            size="small"
            :class="type == 3 ? 'heightLight' : ''"
            @click="getData(3)"
            >荣誉资质</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="success"
            icon="el-icon-s-order"
            @click="isSort = true"
            v-if="type == 3 && !isSort"
            >修改排序</el-button
          >
          <el-button
            type="success"
            icon="el-icon-s-order"
            @click="sort()"
            v-if="type == 3 && isSort"
            >保存排序</el-button
          >
          <el-button
            type="success"
            icon="el-icon-s-order"
            @click="addNew()"
            v-if="type == 3 || canAdd"
            >添加</el-button
          >
          <el-button
            type="success"
            icon="el-icon-edit"
            @click="seeOrEdit()"
            v-if="type == 1 || type == 2"
            >{{ isEdit ? "查看" : "编辑" }}</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(deleteArr)"
            v-if="type == 3"
            >批量删除</el-button
          >
        </div>
      </el-row>

      <!-- =================== -->
      <div class="editor-C" v-if="type != 3">
        <el-form ref="ruleForm" :model="ruleForm" label-width="80px">
          <el-form-item label="所属类别">
            <el-select
              v-model="ruleForm.type"
              placeholder="请选择所属类别"
              :disabled="!isEdit"
            >
              <el-option
                v-for="item in list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="editWrap">
          <editor-vue
            class="editor"
            :value="ruleForm.text"
            @input="(res) => (ruleForm.text = res)"
            :disabled="!isEdit"
          >
          </editor-vue>
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="addNew2" :disabled="!isEdit"
            >确 定</el-button
          >
        </div>
      </div>
      <!-- =================== -->
      <el-table
        :data="tableData"
        border
        row-key="id"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        v-if="type == 3"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column prop="oldName" label="名称"> </el-table-column>
        <el-table-column prop="text" v-if="type != 3" label="内容">
          <template slot-scope="scope">
            <span>{{ decodeURI(scope.row.text) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="预览">
          <template slot-scope="scope">
            <el-image
              style="width: 1.25rem; height: 1.25rem"
              v-show="scope.row.fileUrl"
              :src="
                scope.row.fileUrl
                  ? baseURL + scope.row['fileUrl'] + scope.row['newName']
                  : ''
              "
              :preview-src-list="srcList"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="排序" >
          <template slot-scope="scope">
            <span  v-show="!isSort">{{ scope.row.sort }}</span>
              <el-input :ref="scope.row.id" class="inputStyle" step=1 @blur="doNotSame"  v-show="isSort" type="number"  v-model="scope.row.sort" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="addNew(scope.row)"
              v-if="type != 3"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              @click="handleDelete(scope.row.id)"
              v-if="type == 3"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        title="上传荣誉资质图"
        :visible.sync="dialogVisible2"
        width="520px"
        :close-on-click-modal="false"
        :before-close="handleClose"
      >
        <el-upload
          class="upload-demo"
          :before-upload="beforeUpload"
          :http-request="upload"
          :accept="'.jpg,.jpeg,.png,.JPG,.JPEG'"
          ref="upload"
          action=""
          :on-remove="removeFile"
          :on-success="uploadFile"
          multiple
        >
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelUpload()">取 消</el-button>
          <el-button type="primary" @click="getFileRes()">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getCompanyIntro,
  getHonorPic,
  addHonorPic,
  delHonorPic,
  uploadHonorPic,
  sortHonorPic
} from "@/api/manage";
import Sortable from "sortablejs";
import config from "@/config/url.config";
import { addCompanyIntro, editCompnayIntro, editHonorPic } from "@/api/manage";
import editorVue from "@/components/txtModule/richText.vue";
export default {
  
  data() {
    return {
      type: 1,
      sameId:'',
      isSort: false,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      ryId: "",
      tableData: [],
      baseURL: config.baseURL,
      dialogVisible2: false,
      newFile: new FormData(),
      fileObj: {},
      selectArr: [],
      srcList: [],
      canAdd: false,
      deleteArr: [],
      ruleForm: {
        text: "",
        type: "",
      },
      val: "",
      isEdit: false,
      editId: "",
      picturesList: [],
      list: [
        { id: 1, name: "公司简介" },
        { id: 2, name: "企业文化" },
        { id: 3, name: "荣誉资质" },
      ],
      addShow: false,
      sortArr:[],
       watchList:[]
    };
  },
  components: {
    editorVue,
  },
  created() {
    console.log('设备',navigator.userAgent);
    this.getData(1);
  },
  mounted() {},
  methods: {
   async sort() {
      // this.isSort = true

      this.sortArr=[]
      for (let i = 0; i < this.tableData.length-1; i++) {
        for (let j = 0; j < this.tableData.length - i-1; j++) {
          let temp = JSON.parse(JSON.stringify(this.tableData[j]));
          if (this.tableData[j].sort > this.tableData[j + 1].sort) {
            this.tableData[j] = JSON.parse(
              JSON.stringify(this.tableData[j + 1])
            );
            this.tableData[j + 1] = temp;
          }
        }
      }
      this.tableData.map(item=>{
        this.sortArr.push(item.id)
      })
      console.log("this.sortArr", this.sortArr);
      let res  = await sortHonorPic({ids:JSON.stringify(this.sortArr)})
      if(res.data=='200'){
        this.$message.success('修改排序成功！')
      }
      this.getData(3)
      this.isSort = false;
    },

    seeOrEdit() {
      this.isEdit = !this.isEdit;
    },
    async getData(type) {
      //获取公司简介，企业文化或荣誉资质
      this.type = type;
      this.isEdit = false;
      this.tableData = [];
      this.srcList = [];
      if (type == 1 || type == 2) {
        console.log('获取新闻2');
        let res = await getCompanyIntro({ type: type });
        if (res.code == "200") {
          //console.log("res", res);
          if (!res.data) {
            this.canAdd = true;
            return;
          }
          let replaceTxt = 'http://116.206.94.117:8195//uploading'
      let newTxt = 'http://101.89.182.189:8191//uploading'
          this.ruleForm.text = decodeURI(res.data.text).replace(new RegExp(replaceTxt,'g'),newTxt);
          this.ruleForm.type = res.data.type;
          this.editId = res.data.id;
          // this.tableData.push(res.data);
        }
      } else if (type == 3) {
        this.watchList=[]
        let res = await getHonorPic();
        if (res.code == "200") {
          this.picturesList = [];
          this.ryId = res.data.id;
          //this.tableData = res.data.pictures;
          this.tableData = res.data;
          this.tableData.map((item) => {

            this.watchList.push(item.sort)
            let url = item.fileUrl
              ? config.baseURL + item["fileUrl"] + item["newName"]
              : "";
            this.srcList.push(url);
            this.picturesList.push(item.id);
          });
         // console.log("this.tableData", this.tableData);
        } else {
          this.tableData = [];
        }
      }
    },
    addNew(data) {
      //新增
      if (!data && (this.type == 1 || this.type == 2)) {
        this.$router.replace({
          name: "aboutUsAdd",
          params: { typeOf: "add" },
        });
      } else if (data && (this.type == 1 || this.type == 2)) {
        this.$router.replace({
          name: "aboutUsAdd",
          params: {
            typeOf: "edit",
            id: data.id,
            text: data.text,
            type: data.type,
          },
        });
      } else if (this.type == 3) {
        this.dialogVisible2 = true;
        this.selectArr = [];
      }
    },
    handleDelete(ids) {
      //删除以及批量删除
      if (ids.length == 0) {
        return this.$message.error("未选择删除项");
      }
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let param = {};
          param.id = this.ryId;
          param.ids = Array.isArray(ids)
            ? JSON.stringify(ids)
            : JSON.stringify([ids]);
          let res = await delHonorPic(param);
          if (res.code == "200") {
            this.$message.success("删除成功！");
            this.getData(3);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSelectionChange(val) {
      //多选操作,批量删除
      this.deleteArr = [];
      val.map((item) => {
        this.deleteArr.push(item.id);
      });
    },
    beforeUpload(file) {
      //文件上传之前的钩子
      if (file) {
        let arr = ["image/jp2", "image/jepg", "image/png", "image/jpeg"];
        if (arr.includes(file.type)) {
          this.newFile.append("file", file);
          let newFile = new FormData();
          newFile.append("file", file);
          this.fileObj[file.name] = newFile;
        } else {
          this.$message.error("荣誉资质图只能上传jpg/png格式文件！");
          return false;
        }
      } else {
        return false;
      }
    },
    upload() {
      //文件上传时的钩子
    },
    removeFile(file, fileList) {
      //删除文件时的钩子
      for (let k in this.fileObj) {
        if (k == file.name) {
          delete this.fileObj[k];
        }
      }
    },
    uploadFile(response, file, fileList) {
      //文件上传成功时的钩子
    },
    handleClose(done) {
      //取消上传
      this.dialogVisible2 = false;
      this.fileObj = {};
      this.selectArr = [];
      this.$refs.upload.clearFiles();
    },
    cancelUpload() {
      //取消上传
      this.dialogVisible2 = false;
      this.fileObj = {};
      this.selectArr = [];
      this.$refs.upload.clearFiles();
    },
    async getFileRes() {
      //确认上传图片
      if (JSON.stringify(this.fileObj) != "{}") {
        this.dialogVisible2 = false;
        let flag=false
        for (let k in this.fileObj) {
          let res = await uploadHonorPic(this.fileObj[k]);
          console.log("res", res);
          this.dialogVisible2 = false;
          if (res.code == 250) {
            if(!flag){
              flag=true
              return this.$message.error("文件上传失败！");
            }
            
          } else if (res.code == 200) {
            // this.selectArr.push(res.data.id);//荣誉资质图新增的插图id集合
            //this.picturesList.push(res.data.id)//荣誉资质图所有的插图id集合
           if(!flag){
              this.$message.success("上传荣誉资质图成功！");
              flag=true
           }
             
          }
        }
        this.getData(3);
        //  this.addPic();
        this.fileObj = {};
        this.$refs.upload.clearFiles(); //上传文件结束后清除列表
      } else if (JSON.stringify(this.fileObj) == "{}") {
        return this.$message.error("未选择图片！");
      }
    },
    // async addPic() {
    //   let res = await addHonorPic({ ids: JSON.stringify(this.selectArr) });
    //   if (res.code == "200") {
    //     this.$message.success("上传荣誉资质图成功！");
    //     this.selectArr = [];
    //     this.getData(3);
    //   }else if (res.code=='250'){//如果报250，则说明已有数据，应该调用编辑接口
    //    //console.log('this.picturesList',this.picturesList);
    //     this.editPic()
    //   }
    // },
    async editPic() {
      let param = {};
      param.id = this.ryId;
      param.ids = JSON.stringify(this.picturesList);
      let res = await editHonorPic(param);
      if (res.code == "200") {
        this.$message.success("上传荣誉资质图成功！");
        this.getData(3);
      }
    },
    async addNew2() {
      //确认新增
      if (!this.isEdit) {
        //新增
        if (this.ruleForm.text.length == 0) {
          return this.$message.error("内容不能为空！");
        } else if (this.ruleForm.type == "") {
          return this.$message.error("请选择所属类别！");
        }
        //必填项不能为空，否则不能上传
        this.ruleForm.text = encodeURI(this.ruleForm.text + "");
        let res = await addCompanyIntro(this.ruleForm);
        if (res.code == 200) {
          this.$message.success("添加成功！");
          this.ruleForm.text = "";
          this.ruleForm.type = "";
        }
      } else {
        //编辑状态
        let param = {};
        param.id = this.editId;
        param.text = encodeURI(this.ruleForm.text + "");
        param.type = this.ruleForm.type;
        let res = await editCompnayIntro(param);
        if (res.code == 200) {
          this.$message.success("编辑成功！");
          this.getData(this.type);
        }
      }
    },
    cancel() {
      this.isEdit = false;
    },
    doNotSame(e){
      //排序时input失去焦点，判断是否有重复
      let val = e.target.value
       let reg = /(^[1-9]\d*$)/
      // if(this.watchList.includes(+val)){
      //   this.$message.error('排序号有重复，请重新输入！')
      //   this.$refs[this.sameId].focus()
      // }else 
      if(!reg.test(val)){
        this.$message.error('序号只能是正整数！')
        this.$refs[this.sameId].focus()
      }
    }
  },
  computed: {
  	leaveDataNew() {
        return JSON.parse(JSON.stringify(this.tableData))//watch监听要求
  	},
 },
  watch: {
    leaveDataNew:{
      handler:function(newVal,oldVal){
        this.watchList=[]
        if(newVal.length!==0&&oldVal.length!==0){
           for(let i =0;i<newVal.length;i++){
               this.watchList.push(oldVal[i].sort)
               //动态获取排序更改前一次的sort值组成的数组
           }
          for(let i =0;i<newVal.length;i++){
            if(oldVal[i].sort!=newVal[i].sort){
              //若此次变更与之前有重复，则获取的到变更列对应的id
         //  console.log(this.tableData[i].id);
               this.sameId=this.tableData[i].id
            }
          }
        }
      },
      deep:true
    }
  }
};
</script>

<style lang="less" scoped>
#businessList {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.red {
  color: #f56c6c;
}
.heightLight {
  color: #3a8ee6;
  border-color: #3a8ee6;
  outline: 0;
  background-color: #ecf5ff;
}
.left {
  float: left;
}
.right {
  float: right;
}
.inputStyle /deep/ .el-input__inner {
  border: none;
  outline: none;
      height: 29px;
    border: 1px solid #ccc;
    border-radius: 6px;
    width: 150px;
}
</style>